<template>
  <div>
    <nav class="quiz-nav isActive" v-if="step <= steps">
      <div class="">
        <p class="mb-1 text-center overview">{{ step }}/{{ steps }}</p>
        <ProgressBar :index="step" :count="steps"></ProgressBar>
      </div>
    </nav>
  </div>
</template>

<script>
import ProgressBar from './common/ProgressBar'
export default {
  components: {
    ProgressBar: ProgressBar
  },
  mounted() {
    let routes = this.$router.options.routes
    const regex = /\/\d/g
    const filtered = routes.filter(route => route.path.match(regex))
    filtered.sort(function(a, b) {
      return parseInt(a.path.substring(1)) - parseInt(b.path.substring(1))
    })
    filtered.forEach(route => {
      this.order.push(route.name)
    })
    var index = this.order.indexOf(this.$route.name)
    this.step = index + 1

    let _self = this
    this.$eventBus.$on('quiz-nav', function(payLoad) {
      if (payLoad == 'prev') {
        _self.navigatePrev()
      } else {
        _self.navigateNext()
      }
    })
  },
  data() {
    return {
      order: [],
      steps: 5,
      step: 1,
      eventCanNext: false
    }
  },
  computed: {
    notResult() {
      return true
    },
    sex: {
      get() {
        return this.$store.state.sex
      }
    },
    canNext() {
      if (this.step > 4 && this.step < 16) {
        return this.eventCanNext
      }
      return true
    }
  },
  methods: {
    nextBtnTxt: function() {
      if (this.order.indexOf(this.$route.name) == this.order.length - 1) {
        return 'Finish'
      }
      return 'Neste'
    },

    togglePrevious() {
      if (this.$route.name == this.order[0]) {
        return false
      }
      return true
    },
    navigateNext() {
      var index = this.order.indexOf(this.$route.name)
      this.step = index + 2

      if (index > -1 && index < this.order.length - 1) {
        this.$router.push('/' + (index + 2) + '/')
      }
    },
    navigatePrev() {
      var index = this.order.indexOf(this.$route.name)
      this.step = index
      if (index > 0 && index < this.order.length) {
        this.$router.push('/' + index + '/')
      }
    }
  },
  watch: {
    $route(to, from) {
      setTimeout(function() {
        jQuery('html, body')
          .stop()
          .animate({ scrollTop: 0 }, 300, 'swing')
      }, 200)
      var index = this.order.indexOf(to.name)
      this.step = index + 1
      if (index == 5) {
        setTimeout(function() {
          jQuery('body').addClass('bg-secondary')
        }, 300)
      } else {
        jQuery('body').removeClass('bg-secondary')
      }
    }
  }
}
</script>
<style scoped>
.overview {
  font-weight: bold;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/Navigation.vue